import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function settingReceiptStart(selectedOutlet) {
  const formattedOutlet = {
    'Outlet Id': selectedOutlet.id,
    'Business Id': selectedOutlet.business_id,
    'Outlet Name': selectedOutlet.name,
    'Outlet Phone': selectedOutlet.phone_number,
    'Outlet Address': selectedOutlet.address,
    'Outlet City': selectedOutlet.city,
    'Outlet Province': selectedOutlet.province,
    'Outlet Zip': selectedOutlet.postal_code,
    'Outlet Notes': selectedOutlet.notes === null ? '' : selectedOutlet.notes,
  };
  pushClevertapEvent('Setting Receipt Start', formattedOutlet);
}

export function settingReceiptSave(logo, selectedOutlet, outletId, businessId) {
  pushClevertapEvent('Setting Receipt Save Successful', {
    'Outlet Id': outletId,
    'Business Id': businessId,
    'Outlet Name': selectedOutlet.name,
    'Outlet Phone': selectedOutlet.phone_number,
    'Outlet Address': selectedOutlet.address,
    'Outlet City': selectedOutlet.city,
    'Outlet Province': selectedOutlet.province,
    'Outlet Zip': selectedOutlet.postal_code,
    'Outlet Notes': selectedOutlet.notes === null ? '' : selectedOutlet.notes,
    'Outlet Logo': logo ? 'yes' : 'no',
    'Outlet Website': selectedOutlet.website ? 'yes' : 'no',
    'Outlet Twitter': selectedOutlet.twitter ? 'yes' : 'no',
    'Outlet Facebook': selectedOutlet.facebook ? 'yes' : 'no',
    'Outlet Instagram': selectedOutlet.instagram ? 'yes' : 'no',
  });
}

export function settingReceiptUploadLogo(outlet) {
  pushClevertapEvent('Setting Receipt Upload Outlet Logo', {
    'Outlet Id': outlet.id,
    'Business Id': outlet.business_id,
    'Outlet Name': outlet.name,
    'Outlet Phone': outlet.phone_number,
    'Outlet Address': outlet.address,
  });
}

export function settingReceiptUpdateWebsite(outlet) {
  pushClevertapEvent('Setting Receipt Update Outlet Website', {
    'Outlet Id': outlet.id,
    'Business Id': outlet.business_id,
    'Outlet Name': outlet.name,
    'Outlet Phone': outlet.phone_number,
    'Outlet Address': outlet.address,
  });
}

export function settingReceiptUpdateTwitter(outlet) {
  pushClevertapEvent('Setting Receipt Update Outlet Twitter', {
    'Outlet Id': outlet.id,
    'Business Id': outlet.business_id,
    'Outlet Name': outlet.name,
    'Outlet Phone': outlet.phone_number,
    'Outlet Address': outlet.address,
  });
}

export function settingReceiptUpdateFacebook(outlet) {
  pushClevertapEvent('Setting Receipt Update Outlet Facebook', {
    'Outlet Id': outlet.id,
    'Business Id': outlet.business_id,
    'Outlet Name': outlet.name,
    'Outlet Phone': outlet.phone_number,
    'Outlet Address': outlet.address,
  });
}

export function settingReceiptUpdateInstagram(outlet) {
  pushClevertapEvent('Setting Receipt Update Outlet Instagram', {
    'Outlet Id': outlet.id,
    'Business Id': outlet.business_id,
    'Outlet Name': outlet.name,
    'Outlet Phone': outlet.phone_number,
    'Outlet Address': outlet.address,
  });
}
